/**
 * Contract playtime credit as the server counts it. The web reads the server's figure
 * instead of adding friendly credit itself, so the friendly rule (up to one full match
 * of credit a day) lives only in the backend and cannot drift here.
 */

export const finiteNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

const toNumber = (value) => (value == null || value === '' ? NaN : Number(value));

/**
 * Whole matches a contract has banked this season, as the server counts them.
 *
 * GET /league/players/:id appends this season's figure to
 * `number_of_matches_per_season`: official matches plus friendly credit
 * (backend `contractPlaytimeHelper.getEffectivePlayedGames`), the same
 * figure it judges this season's playtime dot by. `current_stats.played_games`
 * leaves friendly credit out, so it disagreed with the dot.
 *
 * Rounded down: the server counts a promise as met only at `>= play_time`,
 * unrounded, and a floored figure reaches `play_time` at exactly that point.
 * Rounding to nearest would show 8 / 8 next to a missed dot at 7.5.
 * Falls back to `current_stats.played_games` when the array is missing.
 */
export const contractMatchesThisSeason = (contract) => {
  const perSeason = contract?.number_of_matches_per_season;
  const banked =
    Array.isArray(perSeason) && perSeason.length > 0
      ? toNumber(perSeason[perSeason.length - 1])
      : NaN;
  const value = Number.isFinite(banked)
    ? banked
    : toNumber(contract?.current_stats?.played_games);
  return Number.isFinite(value) ? Math.floor(value) : null;
};
